// Functional Imports
import React, { useState, useContext, useEffect } from "react";
import { API } from "aws-amplify";
import { useMediaQuery } from "@mui/material";
import fileUpload from "../../../common/utils/upload-file.js";

// Icon and Style Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import "./index.css";

// Local Components Import

import CreateUser from "./Components/CreateUpdateUser";
import { toast } from "react-toastify";

import ConfirmDeleteModal from "./Components/ConfirmDeleteModal";
import { Table } from "flowbite-react";
import UsersListMobile from "./UsersListMobile.jsx";
import { Pagination } from "flowbite-react";
import "bootstrap/dist/css/bootstrap.min.css";
import Context from "../../../Context/Context.jsx";
import UserModal from "../modals/UserModal.jsx";
import { FaEye } from "react-icons/fa6";
import {
  getCountryNameFromCode,
  getCountryCodeFromName,
  getCountryNameFromValue,
} from "../../../Utils/country-mapping.js";

const UsersList = ({ userCheck, setUserCheck }) => {
  //Context States
  const Ctx = useContext(Context);
  const UtilCtx = useContext(Context).util;
  const { instructorList, getInstructorList } = useContext(Context);

  //User Details States
  const [name, setName] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [status, setStatus] = useState("Active");
  const [balance, setBalance] = useState("");
  const [cognitoId, setCognitoId] = useState("");
  const [currentMonthZPoints, setCurrentMonthZPoints] = useState(0);
  const [lastMonthZPoints, setLastMonthZPoints] = useState(0);
  const [joiningDate, setJoiningDate] = useState(0);
  const [createButton, setCreateButton] = useState("");
  const [userImage, setUserImage] = useState("");
  // Other States
  const [countryCode, setCountryCode] = useState("91");
  const [isUserAdd, setIsUserAdd] = useState(false);
  const [userStatus, setUserStatus] = useState("Active");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showUserAdd, setShowUserAdd] = useState(false);
  const isMobileScreen = useMediaQuery("(max-width: 600px)");
  const [amount, setAmount] = useState(0);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  const itemsPerPage = 5;
  const [totalPages, setTotalPages] = useState(
    Math.ceil(Ctx.userList.length / itemsPerPage)
  );
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const normalizeStatus = (status) => {
    if (!status) return "";
    const s = status.toLowerCase();
    if (s === "active") return "Active";
    if (s === "inactive") return "InActive";
    return "";
  };

  const filterUsersByStatus = (status) => {
    if (status === "all") {
      return Ctx.userList;
    }
    return Ctx.userList.filter(
      (user) => normalizeStatus(user.status) === status
    );
  };

  const availableStatuses = [
    "all",
    ...Array.from(
      new Set(
        Ctx.userList
          .map((user) => normalizeStatus(user.status))
          .filter((s) => s !== null)
      )
    ),
  ];

  const filter2 = filterUsersByStatus(userStatus);
  // console.log("filtter2:", filter2);
  // Search functionality
  const searchedUserList = filter2?.filter((user) => {
    return (
      (typeof user?.userName === "string" &&
        user.userName.toLowerCase().includes(searchQuery.toLowerCase())) ||
      user?.emailId?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user?.phoneNumber?.includes(searchQuery)
    );
  });
  const searchinstructorList = instructorList.filter((user) => {
    return (
      (typeof user?.name === "string" &&
        user.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
      user?.emailId?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });
  // console.log("searched:", searchedUserList);
  const activeUserList = searchedUserList.filter((user) => !user.isArchived);

  // Sort functionality
  activeUserList.sort((a, b) => {
    return b.joiningDate - a.joiningDate;
  });

  const handleToggleUserAdd = () => {
    setUserCheck((prevState) => (prevState === 1 ? 0 : 1));
    setIsUserAdd((prevState) => !prevState);
  };

  const formatDate = (epochDate) => {
    const timestamp = parseInt(epochDate);
    if (isNaN(timestamp)) return "N/A";

    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return "N/A";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  useEffect(() => {
    setTotalPages(Math.ceil(activeUserList.length / itemsPerPage));
  }, [activeUserList]);

  const filteredUserList = activeUserList.slice(startIndex, endIndex);

  const resetForm = () => {
    setName("");
    setEmail("");
    setPhoneNumber("");
    setStatus("");
    setBalance("");
  };

  const sendInvoice = async (cognitoId) => {
    UtilCtx.setLoader(true);
    const pa = "Bworkz@ybl";
    const pn = "Bworkz";
    const am = 10;
    try {
      const res = await API.post("user", `/user/send-email/Bworkz`, {
        body: {
          pa,
          pn,
          am,
          cognitoId,
        },
      });
      console.log(res);
      alert(res.message);
      UtilCtx.setLoader(false);
    } catch (e) {
      console.error("Send reminder error:", e);
      alert("Failed to send reminder");
      UtilCtx.setLoader(false);
    }
  };
  const requestSort = (key) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getInitials = (name) => {
    if (!name) return "";
    const initials = name
      ?.split(" ")
      ?.map((word) => word?.charAt(0)?.toUpperCase())
      ?.join("");
    return initials;
  };
  const getColor = (name) => {
    if (!name) return "#fdf6c6"; // fallback light yellow-gray

    const colors = [
      "#fff9db",
      // "#fff3b0",
      // "#ffe66d",
      // "#ffec99",
      // "#fdf6c6",
    ];
    const index = name.length % colors.length;
    return colors[index];
  };

  const mobileProps = {
    userCheck,
    setUserCheck,
    phoneNumber,
    name,
    email,
    status,
    cognitoId,
    balance,
    countryCode,
    // productType,
    // selectedProductAmount,
    createButton,
    showUserAdd,
    isModalOpen,
    // setPaymentDate,
    // paymentDate,
    setStatus,
    setCognitoId,
    setShowUserAdd,
    setPhoneNumber,
    setCreateButton,
    setIsModalOpen,
    setEmail,
    setCountryCode,
    setName,
    setBalance,
    // setProductType,
    // setSelectedProductAmount,
    userStatus,
    setUserStatus,
    searchQuery,
    setSearchQuery,
    currentPage,
    setCurrentPage,
    filteredUserList,
    activeUserList,
    // handleDeleteUser,
    formatDate,
    availableStatuses,
    itemsPerPage,
    requestSort,

    filter2,
    // setShowDeleteModal,
    // showDeleteModal,
    // confirmDelete,
    // confirmDelete,
  };

  return (
    <>
      {isMobileScreen ? (
        <UsersListMobile {...mobileProps} />
      ) : (
        <div className={`w-full md:w-[calc(100%-5rem)] mx-auto mt-0 md:mt-10 flex flex-col h-full transition-colors duration-200 ${
          Ctx.isDarkMode ? 'bg-black' : 'bg-white'
        }`} style={{ fontFamily: "Inter, sans-serif" }}>
          {/* Header Section */}
          <div className={`w-full px-3 md:px-8 py-3 md:py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-4 border-b ${Ctx.isDarkMode ? 'border-[#2a2a2a]' : 'border-gray-200'}`}>
            <div className="flex items-center gap-2 sm:gap-4">
              <h1 className={`text-xl md:text-3xl font-bold ${Ctx.isDarkMode ? 'text-white' : 'text-black'}`}>Members</h1>
            </div>
            <div className="flex items-center gap-2 sm:gap-4 w-full sm:w-auto">
              <button
                className="w-full sm:w-auto px-3 md:px-4 py-1.5 md:py-2 bg-[#FDCF08] text-black font-semibold rounded-lg flex items-center justify-center gap-1.5 md:gap-2 hover:bg-[#f0c000] transition-colors text-xs md:text-sm"
                style={{ fontFamily: "Inter, sans-serif" }}
                onClick={() => {
                  setIsUserAdd(true);
                  setCreateButton(true);
                  setShowUserAdd(true);
                }}
              >
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 3V13M3 8H13" stroke="black" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <span>Add New Member</span>
              </button>
            </div>
          </div>

          {/* Modal Overlay */}
          <div
            className={
              showUserAdd || isModalOpen ? "showBox open" : "hidden"
            }
          >
            <CreateUser
              createButton={createButton}
              setCreateButton={setCreateButton}
              phoneNumber={phoneNumber}
              cognitoId={cognitoId}
              balance={balance}
              status={status}
              userImage={userImage}
              email={email}
              countryCode={countryCode}
              name={name}
              imageUrl={imageUrl}
              setImageUrl={setImageUrl}
              setPhoneNumber={setPhoneNumber}
              setBalance={setBalance}
              setStatus={setStatus}
              setEmail={setEmail}
              setCountryCode={setCountryCode}
              setName={setName}
              setShowUserAdd={setShowUserAdd}
              currentMonthZPoints={currentMonthZPoints}
              lastMonthZPoints={lastMonthZPoints}
              setIsModalOpen={setIsModalOpen}
              amount={amount}
            />
          </div>

          {/* Main Content */}
          <div className="flex-1 overflow-y-auto px-3 md:px-8 py-3 md:py-6">
            {/* Search and Filter Section */}
            <div className={`w-full mb-6 p-4 md:p-6 rounded-lg border ${Ctx.isDarkMode ? 'bg-[#0f0f0f] border-[#2a2a2a]' : 'bg-gray-50 border-gray-200'}`}>
              <div className="flex flex-col gap-4 md:gap-6">
                <div className="w-full">
                  <label className={`text-xs md:text-sm font-medium block mb-2 ${Ctx.isDarkMode ? 'text-white' : 'text-gray-700'}`}>
                    Search Members
                  </label>
                  <div className="flex gap-2">
                    <input
                      className={`flex-1 px-3 md:px-4 py-2 rounded-lg text-xs md:text-sm transition-all duration-200 outline-none ${
                        Ctx.isDarkMode 
                          ? 'bg-[#1a1a1a] text-white placeholder-gray-400 focus:ring-2 focus:ring-[#FDCF08]'
                          : 'bg-white border border-gray-200 text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-[#FDCF08]'
                      }`}
                      type="text"
                      placeholder="Search by name, email or phone"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button
                      className="px-3 md:px-4 py-2 bg-[#FDCF08] text-black font-semibold rounded-lg hover:bg-[#f0c000] transition-colors text-xs md:text-sm"
                      onClick={() => setSearchQuery("")}
                    >
                      Clear
                    </button>
                  </div>
                </div>

                <div className="w-full">
                  <label className={`text-xs md:text-sm font-medium block mb-2 ${Ctx.isDarkMode ? 'text-white' : 'text-gray-700'}`}>
                    Status Filter
                  </label>
                  <select
                    className={`w-full h-10 md:h-11 px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-xs md:text-sm transition-all duration-200 outline-none ${
                      Ctx.isDarkMode 
                        ? 'bg-[#1a1a1a] text-white focus:ring-2 focus:ring-[#FDCF08]' 
                        : 'bg-white border border-gray-200 text-gray-900 focus:ring-2 focus:ring-[#FDCF08]'
                    }`}
                    id="userStatusFilter"
                    value={userStatus}
                    onChange={(e) => setUserStatus(e.target.value)}
                  >
                    {availableStatuses.map((status) => (
                      <option key={status} value={status}>
                        {status === "all" ? "All Members" : status}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Users Table */}
            <div className="overflow-x-auto w-full">
              <Table striped>
                <Table.Head className={`font-semibold text-center ${Ctx.isDarkMode ? 'bg-[#1a1a1a]' : 'bg-gray-50'}`}>
                  <Table.HeadCell className={Ctx.isDarkMode ? 'text-gray-300' : 'text-gray-700'}></Table.HeadCell>
                  <Table.HeadCell className={Ctx.isDarkMode ? 'text-gray-300' : 'text-gray-700'}>Name</Table.HeadCell>
                  <Table.HeadCell className={Ctx.isDarkMode ? 'text-gray-300' : 'text-gray-700'}>Email</Table.HeadCell>
                  <Table.HeadCell className={Ctx.isDarkMode ? 'text-gray-300' : 'text-gray-700'}>Phone</Table.HeadCell>
                  <Table.HeadCell className={Ctx.isDarkMode ? 'text-gray-300' : 'text-gray-700'}>Country</Table.HeadCell>
                  <Table.HeadCell className={Ctx.isDarkMode ? 'text-gray-300' : 'text-gray-700'}>Joining Date</Table.HeadCell>
                  <Table.HeadCell className={Ctx.isDarkMode ? 'text-gray-300' : 'text-gray-700'}>Attendance</Table.HeadCell>
                  <Table.HeadCell className={Ctx.isDarkMode ? 'text-gray-300' : 'text-gray-700'}>Due</Table.HeadCell>
                  <Table.HeadCell className={Ctx.isDarkMode ? 'text-gray-300' : 'text-gray-700'}>Action</Table.HeadCell>
                </Table.Head>
                <Table.Body className={`divide-y ${Ctx.isDarkMode ? 'divide-[#2a2a2a]' : 'divide-gray-200'}`}>
                  {filteredUserList.map((user) => {
                    if (!user.isArchived) {
                      return (
                        <Table.Row key={user.cognitoId} className={Ctx.isDarkMode ? 'bg-black hover:bg-[#0f0f0f]' : 'bg-white hover:bg-gray-50'}>
                          <Table.Cell>
                            {user.imgUrl ? (
                              <img
                                src={user.imgUrl}
                                alt={user.userName}
                                className="h-10 w-10 rounded-full object-cover"
                              />
                            ) : (
                              <div
                                className="h-10 w-10 rounded-full flex items-center justify-center text-black text-sm font-medium"
                                style={{
                                  backgroundColor: getColor(user.userName),
                                }}
                              >
                                {getInitials(user.userName)}
                              </div>
                            )}
                          </Table.Cell>
                          <Table.Cell className={`font-semibold text-center ${Ctx.isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                            {user.userName}
                          </Table.Cell>
                          <Table.Cell className={`font-semibold text-center overflow-hidden ${Ctx.isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                            {user.emailId.split("@")[0]}@
                          </Table.Cell>
                          <Table.Cell className={`font-semibold text-center ${Ctx.isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                            {user.phoneNumber}
                          </Table.Cell>
                          <Table.Cell className={`font-semibold text-center ${Ctx.isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                            {user.country}
                          </Table.Cell>
                          <Table.Cell className={`font-semibold text-center ${Ctx.isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                            {formatDate(user.joiningDate)}
                          </Table.Cell>
                          <Table.Cell className={`font-semibold text-center ${Ctx.isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                            {user.currentMonthZPoints || 0}/{user.lastMonthZPoints || 0}
                          </Table.Cell>
                          <Table.Cell className={`font-semibold text-center ${
                            parseFloat(user.balance) < 0
                              ? Ctx.isDarkMode ? 'text-red-400' : 'text-red-500'
                              : Ctx.isDarkMode ? 'text-gray-200' : 'text-gray-700'
                          }`}>
                            {user.balance}
                          </Table.Cell>
                          <Table.Cell className={`font-semibold text-center ${Ctx.isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                            <button
                              className={`p-2 rounded-md transition-colors ${Ctx.isDarkMode ? 'hover:bg-[#1a1a1a]' : 'hover:bg-gray-100'}`}
                              onClick={() => {
                                setIsUserAdd(false);
                                setIsModalOpen(true);
                                setCognitoId(user.cognitoId);
                                setName(user.userName);
                                setCountryCode(
                                  getCountryCodeFromName(user.country || "91")
                                );
                                setUserImage(user.imgUrl);
                                setEmail(user.emailId);
                                setPhoneNumber(user.phoneNumber);
                                setStatus(user.status);
                                setBalance(user.balance);
                                setAmount(user?.payment?.amount);
                              }}
                              title="View/Edit Member"
                            >
                              <FaEye size={15} color={Ctx.isDarkMode ? '#FDCF08' : '#333'} />
                            </button>
                          </Table.Cell>
                        </Table.Row>
                      );
                    }
                    return null;
                  })}
                </Table.Body>
              </Table>

              {/* Pagination */}
              <div className="flex flex-col sm:flex-row items-center justify-between mt-6 gap-4">
                <div className={`text-xs md:text-sm ${Ctx.isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                  Showing {startIndex + 1} to {Math.min(endIndex, activeUserList.length)} of {activeUserList.length} results
                </div>
                <div className="flex overflow-x-auto sm:justify-end">
                  <Pagination
                    currentPage={currentPage}
                    totalPages={Math.ceil(activeUserList.length / itemsPerPage)}
                    onPageChange={(page) => {
                      setCurrentPage(page);
                      window.scrollTo(0, 0);
                    }}
                    showIcons
                    layout="pagination"
                    className={Ctx.isDarkMode ? 'text-gray-400' : 'text-gray-500'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UsersList;
